import { createClient } from 'graphql-ws';
import PubSub from 'pubsub-js';

// extract the host and protocol from the window location
const { host, protocol } = window.location;

// create a WebSocket link for Subscriptions
const wsProtocol = protocol === 'https:' ? 'wss' : 'ws';

// Current connection state
let isConnected = false;

// PubSub topic for state changes
const stateChangeTopic = 'wsClient.stateChange';

/**
 * Get the current WebSocket connection state
 */
export const getConnectionState = (): boolean => isConnected;

/**
 * Update the connection state and notify subscribers
 */
const updateConnectionState = (connected: boolean) => {
    if (isConnected !== connected) {
        isConnected = connected;
        PubSub.publish(stateChangeTopic, connected);
    }
};

/**
 * Subscribe to WebSocket connection state changes
 * @param callback Function to call when the connection state changes
 * @returns Unsubscribe function
 */
export const onConnectionStateChange = (callback: (connected: boolean) => void) => {
    const subscriptionToken = PubSub.subscribe(stateChangeTopic, (_, connected: boolean) => callback(connected));

    return () => {
        PubSub.unsubscribe(subscriptionToken);
    };
};

const wsClient = createClient({
    url: `${wsProtocol}://${host}/api/subscriptions`,
    lazy: true,
    on: {
        connected: () => {
            updateConnectionState(true);
        },
        closed: () => {
            updateConnectionState(false);
        },
        error: () => {
            updateConnectionState(false);
        },
    },
    shouldRetry: () => true,
    retryAttempts: Infinity,
    retryWait: async retries => {
        // Exponential backoff with max 10 seconds
        const delay = Math.min(1000 * Math.pow(2, retries), 10000);
        await new Promise(resolve => setTimeout(resolve, delay));
    },
});

export default wsClient;
